
import { ProjectGroupFormComponent } from './form/group/project-group-form.component';
import { ProjectGroupModalComponent } from './modal/group/project-group-modal.component';
import { ProjectSwitchModalComponent } from './modal/switch/project-switch-modal.component';
import { ProjectGroupTableComponent } from './table/group/project-group-table.component';
import { ProjectShowComponent } from './show/project-show.component';

import { ProjectFormComponent } from './form/project-form.component';
import { ProjectWatermarkComponent } from './watermark/project-watermark.component';
import { ProjectAccessListComponent } from './access-list/project-access-list.component';
import { ProjectInputChangeComponent } from './input-change/project-input-change.component';

export const ProjectSettingModule = angular.module('topbroker.projectSetting', [])
  .component('projectGroupForm', ProjectGroupFormComponent)
  .component('projectGroupModal', ProjectGroupModalComponent)
  .component('projectSwitchModal', ProjectSwitchModalComponent)
  .component('projectGroupTable', ProjectGroupTableComponent)
  .component('projectShow', ProjectShowComponent)

  .component('projectForm', ProjectFormComponent)
  .component('projectWatermark', ProjectWatermarkComponent)
  .component('projectAccessList', ProjectAccessListComponent)
  .component('projectInputChange', ProjectInputChangeComponent)

  .name;
